import type { TradeInAemStateType } from "../redux/store";
import { getTradeInAemLabel, tradeInAemHeaderDescriptionLabels, tradeInAemHeaderTitleLabels } from "./labels";
import { TradeInAemNavStep } from "./constants";

/**
 * Get labels for the TradeInAemStepHeader component.
 */
export const stepHeaderLabelSelector = (
    state: TradeInAemStateType,
): { titleLabel: string; descriptionLabel: string } => {
    const { tradeInAemNav, tradeInAemVehicleValue, tradeInAemUtils } = state;
    const { step } = tradeInAemNav;
    const valuationFailed = tradeInAemVehicleValue.failed;
    const valuationLoading = tradeInAemVehicleValue.fetching;
    const eHubLoading = tradeInAemUtils.eHub.submitting;
    const eHubFailed = tradeInAemUtils.eHub.failed;

    let titleLabelKey = tradeInAemHeaderTitleLabels[step];
    let descriptionLabelKey = tradeInAemHeaderDescriptionLabels[step];

    if (step === TradeInAemNavStep.VehicleValue || step === TradeInAemNavStep.Summary) {
        if (valuationLoading || eHubLoading) {
            titleLabelKey = "tradeInAemValuationLoadingHeaderTitle";
            descriptionLabelKey = "tradeInAemValuationLoadingHeaderDescription";
        } else if (valuationFailed || eHubFailed) {
            titleLabelKey = "tradeInAemValuationFailedHeaderTitle";
            descriptionLabelKey = "tradeInAemValuationFailedHeaderDescription";
        }
    }

    const [titleLabel, descriptionLabel] = getTradeInAemLabel(state, [titleLabelKey, descriptionLabelKey]);

    return { titleLabel, descriptionLabel };
};
